import { useState } from 'react';

import { BarGraphProps } from './type';
import Typography from '../Typography';
import { formatNumberAsCurrency, getUniqueKey } from '../utils';
import { WrapBarGraphStyle, WrapLabelStyle, WrapBarStyle, BarStyle } from './styled';

const BarGraph = ({ ...props }: BarGraphProps) => {
  const { step, total, data, barWidth, gap, initialLabelType, finalLabelType, color } = props;
  const [selectedBar, setSelectedBar] = useState(null);
  const handleBarClick = (index: number) => {
    setSelectedBar((prevSelectedBar: number) => (prevSelectedBar === index ? null : index));
  };

  return (
    <WrapBarGraphStyle {...props}>
      <WrapLabelStyle {...props}>
        {Array.from(Array(step + 1), (_, index) => index)
          .reverse()
          .map((elem) => (
            <Typography
              key={`${elem}-label-name`}
              color="#5B5D71"
              style={{
                fontSize: '10px',
                fontWeight: 500,
                textAlign: 'right',
              }}
            >
              {initialLabelType || ''}
              {formatNumberAsCurrency(Math.round(total * (elem / step)))}
              {finalLabelType || ''}
            </Typography>
          ))}
      </WrapLabelStyle>
      <div
        style={{
          display: 'flex',
          gap,
          padding: '60px 40px 40px 0px',
        }}
      >
        {data.map(({ value, label, title }, index) => {
          return (
            <WrapBarStyle
              key={getUniqueKey()}
              data-testid={`bar-${index}`}
              onClick={() => handleBarClick(index)}
              isSelected={selectedBar !== null && selectedBar !== index}
              label={label}
              title={title}
            >
              <BarStyle
                color={color}
                isSelected={selectedBar === index}
                graphValue={(value * 100) / total}
                popUpText={`${initialLabelType || ''}${formatNumberAsCurrency(value) || 0}${
                  finalLabelType || ''
                }`}
                size={barWidth}
                data-testid={`bar-span-${index}`}
              />
            </WrapBarStyle>
          );
        })}
      </div>
    </WrapBarGraphStyle>
  );
};

BarGraph.defaultProps = {
  data: [],
  step: 5,
  total: 0,
  barWidth: '12px',
  gap: '20px',
  labelType: '',
  maxWidth: '100%',
  maxHeight: '300px',
};
export default BarGraph;
